/*=========================================================================================
  File Name: moduleProformaState.js
  Description: state of module proforma
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  proformas: []
}
